import { createSlice } from '@reduxjs/toolkit'

import {MAX_GAME_TIME} from "../constants"

const initialState = {
  name: '',
  date: null,//Date format
  isStart: false,
  isFinish: false,
  isPause: false,
  time: 0, //ms format
  isMaxTimeLeft: false
}

export const matchSlice = createSlice({
  name: 'match',
  initialState,
  reducers: {
    setName: (state, {payload: {name}}) => {
      state.name = name;
    },
    setDate: (state, {payload: {date}}) => {
      state.date = date;
    },
    setStart: (state => {
      state.isStart = true
    }),
    setFinish: (state => {
      if(state.isStart) {
        state.isFinish = true
      }
    }),
    setPause: ((state, {payload: {value}}) => {
      if(state.isStart && !state.isFinish) {
        state.isPause = value
      }
    }),
    addTime: (state, {payload: {time}}) => {
      if(state.isStart && !state.isFinish) {
        state.time += time
        if(state.time === MAX_GAME_TIME) {
          state.isPause = true
          state.isMaxTimeLeft = true
        }
      }
    },
    setIsMaxTimeLeft: (state, {payload: {value}}) => {
      state.isMaxTimeLeft = value
    }
  },
})

export const { actions: matchSliceAction, reducer: matchSliceReducer} =  matchSlice